import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import Button from '../../components/Button';
import Processing from '../../components/Processing';
import Api, { Utils } from '../../Api';

import ImageCollection from './image_collection';
import SelectionButton from './selection_button';

import { capitalizeEveryWord } from '../../lib/StringUtils';

import './style.less';

export default class ReatailerProduct extends React.Component {
  static propTypes = {
    buttonText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func
    ]),
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    defaultSelection: PropTypes.array,
    productToken: PropTypes.string
  };

  static defaultProps = {
    buttonText: 'Add to My Bag'
  };

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    Utils.bindThis(
      this,
      [
        'newSelection',
        'removeSelection',
        'changeSelection',
        'changeOption',
        'selections',
        'changeQuantity',
        'goBack',
        'colorOptionRender',
        'loadProduct',
        'onSave',
        'getButtonText'
      ]
    );

    let productToken = null;
    if (props.productToken) {
      productToken = props.productToken;
    } else if (props.params) {
      productToken = props.params.productId;
    }

    let brandToken = null;
    if (props.brandToken) {
      brandToken = props.brandToken;
    } else if (props.params) {
      brandToken = props.params.brandId;
    }

    let retailerToken = null;
    if (props.retailerToken) {
      retailerToken = props.retailerToken;
    } else if (props.params) {
      retailerToken = props.retailerId;
    }

    this.state = {
      productToken: productToken,
      brandToken: brandToken,
      retailerToken: retailerToken,
      product: null,
      brand: null,
      selections: this.props.defaultSelection || [],
      selectableImages: [],
      options_info: null,
      errorMessage: null,
      shake: false
    };
  }

  componentWillReceiveProps(nextProps) {
    let payload = {};

    let productToken = null;
    if (nextProps.productToken) {
      productToken = nextProps.productToken;
    } else if (nextProps.params) {
      productToken = nextProps.params.productId;
    }

    if (this.state.productToken !== productToken) {
      payload.selections = nextProps.defaultSelection || [];
    }

    let brandToken = null;
    if (nextProps.brandToken) {
      brandToken = nextProps.brandToken;
    } else if (nextProps.params) {
      brandToken = nextProps.params.brandId;
    }

    let retailerToken = null;
    if (nextProps.retailerToken) {
      retailerToken = nextProps.retailerToken;
    } else if (nextProps.params) {
      retailerToken = nextProps.params.retailerId;
    }

    payload.productToken = productToken;
    payload.brandToken = brandToken;
    payload.retailerToken = retailerToken;

    this.setState(payload);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.productToken !== this.state.productToken) {
      this.loadProduct();
    }
  }

  onSave(event) {
    event.preventDefault();
    if (this.state.selections.length === 0) {
      this.setState(
        {shake: true},
        () => {
          setTimeout(
            () => { this.setState({shake: false}); },
            825
          );
        }
      );
      return false;
    }
    return this.props.onSave(this.state.productToken, this.state.selections);
  }

  buildImageList(product) {
    let images = [];
    if (product.images && product.images.length > 0) {
      product.images.forEach(image => images.push(image));
    }

    product.options.forEach((productOption) => {
      (productOption.images || []).forEach((image) => {
        images.push(image);
      });
    });

    return images.slice(0, 4);
  }

  componentWillMount() {
    this.loadProduct();
  }

  loadProduct() {
    if (!this.state.productToken) {
      this.setState({
        product: null,
        brand: null,
        options_info: null,
        selectableImages: null,
        selections: []
      });
      return;
    }

    Api.getProduct(this.state.productToken, true)
    .then(
      result => {
        let product = null;
        if (result.products) {
          if (Array.isArray(result.products)) {
            product = result.products[0];
          } else {
            product = result.products[this.state.productToken];
          }
        }

        if (!product) {
          console.error('I cannot seem to have found the product I was looking for: %s.', this.state.productToken);
          console.error(result);
          this.setState({
            error: 'Error loading product information.'
          });
          return;
        }
        let options_info = this.buildOptionsObject(product);
        let selectableImages = this.buildImageList(product);

        try {
          let selections = this.state.selections;

          if (!selections || selections.length <= 0) {
            if (options_info.options.length === 1) {
              selections = [
                {
                  option: options_info.options[0]._option.token,
                  batches: 1
                }
              ];
            } else {
              selections = [];
            }
          }

          this.setState({
            product: product,
            brand: result.brands[product.brand_token],
            options_info: options_info,
            selectableImages: selectableImages,
            selections
          });
        } catch (error) {
          let errorMessage = {
            message: 'Invalid product on marketplace',
            error: error,
            product: product,
            options_info: options_info,
            user: Api.cache.getUser()
          };
          Api.error(JSON.stringify(errorMessage));

          console.error(error);
          console.log(product);
          console.log(options_info);
          this.setState({
            errorMessage: 'this product has an error.'
          });
        }
      }
    );
  }

  newSelection() {
    let nextSelection = this.state.options_info.options.find((option) => {
      let i;
      for (i = 0; i < this.state.selections.length; i++) {
        if (option._option.token === this.state.selections[i].option) return(false);
      }

      return(true);
    });

    if (!nextSelection) {
      console.error("No more remaining selections!");
      return;
    }

    let selections = Utils.clone(this.state.selections);
    selections.push({
      option: nextSelection._option.token,
      batches: 1
    });

    this.setState({ selections });
  }

  changeSelection(token, newToken) {
    let selections = Utils.clone(this.state.selections);
    selections.forEach((selection) => {
      if (selection.option === token) {
        selection.option = newToken;
      }
    });

    this.setState({ selections });
  }

  /* 
   * Changes the option on the given index.
   * We need to know what kind the user has actually changed to stop lookin on that index.
   * We also retrieve the list of availableOptions (unused options) to not select the same option twice.
   * OptionValue is expected as an object containing at least the following keys:
   * * name
   * * kind
   * * option
   */
  changeOption(selectionIdx, optionValue, availableOptions) {
    let kinds = this.state.options_info.kinds;
    let kindLimit = optionValue.kind;

    // Get the token of our index
    let selectedPropToken = this.state.selections[selectionIdx].option;
    // Using the token, let's get the option with the actual dictionary value 
    let selectedProps = availableOptions.find((option) => {
      return(option._option.token === selectedPropToken);
    });
    selectedProps = Utils.clone(selectedProps); // No need to go deep here
    selectedProps[optionValue.kind] = optionValue;
    let selections = Utils.clone(this.state.selections, true);

    let newOption = availableOptions.find((option) => {
      let i;
      for (i = 0; i < kinds.length; i++) {
        if (selectedProps[kinds[i]].name !== option[kinds[i]].name) return(false);
        if (kinds[i] === kindLimit) break;
      }

      return true;
    });

    selections[selectionIdx].option = newOption._option.token;
    this.setState({ selections });
  }

  /*
   * Quantity is number of batches / packs / cases
   */
  changeQuantity(token, quantity) {
    let selections = Utils.clone(this.state.selections);
    let currentSelection = selections.find(selection => selection.option === token);
    if (!currentSelection) {
      currentSelection = {
        option: token
      };
      selections.push(currentSelection);
    }
    currentSelection.batches = parseInt(quantity, 10);

    selections = selections.filter(selection => selection.batches > 0);

    this.setState({ selections });
  }

  removeSelection(token) {
    if (this.state.selections.length <= 1) return;

    let selections = Utils.clone(this.state.selections).filter(selection => selection.option !== token);

    this.setState({ selections });
  }

  colorOptionRender(option, kind, selected) {
    if (option.kind && option.kind.toLowerCase() === 'color') {
      let colorName = '';
      let colorValue = '';
      if (option.option.color) {
        colorName = option.option.color.name;
        if (option.option.color && option.option.color.rgb) {
          colorValue = option.option.color.rgb;
        }

        if (colorValue.length > 0 && colorValue[0] !== '#') {
          colorValue = '#' + colorValue;
        }
      } else {
        colorName = option.name;
      }

      return (
        <span className={'content color-option' + (colorValue === '' ? ' no-color' : '')}>
          <span className="oval" style={{ backgroundColor: colorValue }} />
          <span className="description">{colorName}</span>
        </span>
      );
    }

    return option.name;
  }

  selections() {
    let product = this.state.product;
    
    if (!product) return null;

    let ret = [];
    let allOptions = this.state.options_info.options;

    // Fix names
    allOptions.forEach((option) => {
      let optionArray = [];
      Object.keys(option).forEach((k) => {
        if (k[0] === '_') return;
        optionArray.push(capitalizeEveryWord(option[k].name));
      });
      option._text =  optionArray.join(', ');
    });

    let hideColor = false;
    allOptions.forEach(option => {
      let color = option.Color || option.color || option.Colors || option.colors || null;
      if (!color) {
        hideColor = true;
        return;
      }
      if (!color.option || !color.option.color || !color.option.color.rgb) {
        hideColor = true;
      }
    });

    let selectionList = allOptions.map(option =>
      <SelectionButton
        key={`selection-item-${option._option.token}`}
        unitMultiplier={product.unit_multiplier}
        selectionList={this.state.selections}
        option={option}
        hideColor={hideColor}
        isOnlyOption={allOptions.length === 1}
        onChange={(value) => this.changeQuantity(option._option.token, value / product.unit_multiplier)}
      />
    );

    ret.push(<div className="selection-list" key="selection-list">{selectionList}</div>);

    return ret;
  }

  goBack() {
    let address = `/retailer/${this.state.retailerToken}`;
    if (this.state.brandToken) {
      address += `/brand/${this.state.brandToken}`;
    }
    this.context.router.push(address);
  }

  /**
   * Builds an object based on the product options with the following structure:
   * {
   *   kinds: [],
   *   options: [
   *     {
   *       kindName1: ...,
   *       kindName2: ...,
   *       ...,
   *       _option: { optionObject }
   *     },
   *     ...
   *   ]
   * }
   * This object will help us properly populate the user interface
   */
  buildOptionsObject(product) {
    let ret = {};
    ret.kinds = [];
    if (!product) {
      console.error('no product to build options for!');
      console.error(this);
      return ret;
    }

    if (!product.options) {
      console.error('product has no options');
      console.error(product);
      return ret;
    }
    product.options.forEach((option) => {
      if (ret.kinds.indexOf(option.group_name) >= 0) return;
      ret.kinds.push(option.group_name);
    });

    // Finds all options and suboptions with the same parent.
    // If there are no children with that parent, the `prev` object is returned as-is.
    // If there are any children (even if just 1), the return object is an array where every element is a copy
    // of `prev`, along with the new `group_name` key and its value for each child.
    function findWithParent(parent, prev) {
      let productChildren = product.options.filter((option) => {
        return ((option.parent_token || '') === parent);
      });

      if (productChildren.length === 0) return prev;

      let ret = [];

      // Populate the return array
      productChildren.forEach((option) => {
        // We need a working object. If no previous one is supplied, we create an empty one.
        let optionObject = (prev) ? Utils.clone(prev) : {};
        optionObject[option.group_name] = {
          name: option.name,
          option: option
        };
        optionObject._option = option;

        // Update our color, if we have one.
        if (option.color && option.color.rgb !== '') {
          optionObject._color = option.color;
        }

        // Check if we are parent of anyone.
        let childOptions = findWithParent(option.token, optionObject);

        // Populate the return array properly
        if (Array.isArray(childOptions)) {
          childOptions.forEach((element) => { ret.push(element); });
        } else {
          ret.push(childOptions);
        }
      });

      return ret;
    }

    // Start with all the product options that have no parents (root options)
    ret.options = findWithParent('');

    return ret;
  }

  getSelectionValue() {
    let totalValue = 0;

    this.state.selections.forEach(selection => {
      totalValue += selection.batches * this.state.product.unit_multiplier * this.state.product.wholesale_price_cents
    });

    return `$${Utils.formatCents(totalValue) || 0}`;
  }

  getButtonText() {
    if (typeof this.props.buttonText === 'string') return this.props.buttonText;

    return this.props.buttonText(this.state.selections);
  }

  getProductControls() {
    let product = this.state.product;
    let productSelectionClasses = `product-selection selected-options-${this.state.selections.length}`;

    let styleNames = [ ...this.state.options_info.kinds ];

    let stylesDiv = null;
    styleNames = styleNames.filter(name => !!name);
    if (this.state.options_info.options.length > 1) {
      stylesDiv = <div className="styles">{styleNames.length ? styleNames.join(', ') : 'Style'}</div>
    }

    return (
      <div className="product-controls">
        <div className="product-controls-inner-wrapper">
          <BrandModalHeader brand={this.state.brand} retailerToken={this.state.retailerToken} />
          <div className="product-info">
            <div className="name">{product.name} — ${Utils.formatCents(product.wholesale_price_cents, true)}</div>
            <div className="details">
              <span className="case-size">Case Size <span className="value">{product.unit_multiplier}</span></span>
              <span className="retail-price">Suggested Retail Price: <span className="value">${Utils.formatCents(product.retail_price_cents, true)}</span></span>
            </div>
          </div>
          <div className={productSelectionClasses}>
            <div className="header">
              {stylesDiv}
              <div className="item-quantity">Item Quantity</div>
            </div>
            {this.selections()}
          </div>
          <div className="add-to-cart">
            <Button onClick={this.onSave} waitingState={<Processing />} className={'full-width' + (this.state.shake ? ' shake' : '')}>
              {this.getButtonText()}
              <span className="button-subtotal">{this.getSelectionValue()}</span>
            </Button>
          </div>
          <ProductDescription>{product.description}</ProductDescription>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.productToken) {
      return <div className="retailer-product" />;
    }

    if (this.state.errorMessage) {
      return <div>{this.state.errorMessage}</div>;
    }
    if (this.state.product === null || this.state.brand === null) {
      return <div className="retailer-product"><Processing/></div>;
    }

    return (
      <div className="retailer-product">
        <ImageCollection images={this.state.selectableImages} />
        {this.getProductControls()}
      </div>
    );
  }
}

const BrandModalHeader = ({ brand, retailerToken }) => {
  if (!brand) return <div className="brand-info"/>;

  return (
    <div className="brand-info">
      <Link className="name" to={`/retailer/${retailerToken}/brand/${brand.token}`}>{brand.name}</Link>
      <span className="minimum">{brand.minimum_order_amount_cents ? 'Maker Minimum $' + Utils.formatCents(brand.minimum_order_amount_cents, true) : 'No Minimum'}</span>
    </div>
  );
};

const ProductDescription = ({ children }) => {
  if (!children) return null;

  return (
    <div className="description">
      <div className="header">Description</div>
      <p>{children}</p>
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./src/views/ProductModal/index.js
 **/